"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _moment = _interopRequireDefault(require("moment")),
    _uiKit = require("@devsta/ui-kit"),
    _event = require("@devsta/event"),
    _status = _interopRequireDefault(require("../constants/status"));

require("../styles/_event-item.scss");

var replaceFields = function replaceFields(a, b) {
  return Object.entries(b).reduce(function (a, b) {
    var c = (0, _slicedToArray2["default"])(b, 2),
        d = c[0],
        e = c[1];
    return a.replace(new RegExp(d, "g"), e);
  }, a);
};

function getTimestampFromCreatedDate(a) {
  return a.isSame(new Date(), "day") ? a.fromNow() : a.isSame((0, _moment["default"])().subtract(1, "days"), "day") ? "Yesterday at ".concat(a.format("h:mma")) : a.format("h:mma");
}

function EventItem(a) {
  var b = a.event,
      c = b.createdByGhostUser,
      d = b.createdByUser,
      e = b.metaData,
      f = b.eventType,
      g = b.createdAt,
      h = c || d,
      i = e || {},
      j = i.status,
      k = i.version,
      l = i.editor,
      m = _event.EVENTS[f];
  if (!m || !m.message) return null;
  var n = replaceFields(m.message, {
    "{userName}": "".concat(h.firstName, " ").concat(h.lastName),
    "{status}": _status["default"][j],
    "{version}": k,
    "{editorName}": l ? "".concat(l.firstName, " ").concat(l.lastName) : ""
  }),
      o = c ? _event.EVENT_ICON.GHOST : m.icon,
      p = (0, _moment["default"])(g, ["x", "YYYY-MM-DDTHH:mm:ss.sssZ"]);
  return _react["default"].createElement("div", {
    className: "event-item"
  }, _react["default"].createElement("div", {
    className: "event-item__side"
  }, _react["default"].createElement(_uiKit.Icon, {
    name: o,
    color: "monkey",
    size: 20
  }), _react["default"].createElement("div", {
    className: "event-item__side__line"
  })), _react["default"].createElement("div", {
    className: "event-item__content"
  }, _react["default"].createElement(_uiKit.Text, {
    heading5: !0,
    noMargin: !0
  }, "".concat(h.firstName, " ").concat(h.lastName)), _react["default"].createElement(_uiKit.Text, {
    label: !0
  }, n), _react["default"].createElement(_uiKit.Text, {
    timestamp: !0
  }, getTimestampFromCreatedDate(p))));
}

var _default = (0, _react.memo)(EventItem);

exports["default"] = _default;